import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MDBModalRef } from 'ng-uikit-pro-standard';

import { NgxSpinnerService } from 'ngx-spinner';

import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { Offer } from '../../../../../models/offer.model';
import { PATHS } from '../../../../../models/bary-paths.model';
import { OfferService } from '../../../../../services/offer.service';
import { AlertService } from '../../../../../services/alert.service';

import { mapAsBody } from '../../../../shared/util/request-util';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { BaryOfferFormComponent } from '../../../../shared/ui/forms/bary-offer-form/bary-offer-form.component';
import { BaryButtonComponent, BaryInputTextComponent } from '../../../../shared/components';

@Component({
  selector: 'jhi-modal-new-offer',
  templateUrl: './modal-new-offer.component.html',
  styleUrls: ['./modal-new-offer.component.scss'],
  imports: [TranslateModule, BaryOfferFormComponent, BaryInputTextComponent, BaryButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ModalNewOfferComponent {
  readonly #spinnerService = inject(NgxSpinnerService);
  readonly #translateService = inject(TranslateService);
  readonly #modalRef = inject(MDBModalRef);
  readonly #router = inject(Router);
  readonly #offerService = inject(OfferService);
  readonly #alertService = inject(AlertService);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public formGroup = new FormGroup({
    merchandiseType: new FormControl(null, [Validators.required]),
    serviceType: new FormControl(null, [Validators.required]),
    isControlledTemperature: new FormControl(false, [Validators.required]),
    isHazardousMaterial: new FormControl(false, [Validators.required]),
    name: new FormControl('', [Validators.required]),
  });

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  public handleSubmit(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    const newOffer = new Offer({
      name: this.formGroup.controls['name'].value?.trim(),
      isHazardousMaterial: this.formGroup.controls['isHazardousMaterial'].value!,
      isControlledTemperature: this.formGroup.controls['isControlledTemperature'].value!,
      serviceType: this.formGroup.controls['serviceType'].value!,
      merchandiseType: this.formGroup.controls['merchandiseType'].value!,
    });
    this.#spinnerService.show().then();

    this.#offerService.create(newOffer).pipe(mapAsBody).subscribe(
        offerCreated => {
          this.#router.navigateByUrl(PATHS.MIDDLE_OFFER_ID_EDIT.withId(offerCreated.id)).then(() => {
            this.#alertService.addAlert({
              type: 'success',
              message: this.#translateService.instant('OFFER_MODIFICATION.ALERTS.SAVE'),
            });
          });
        },
        () => {
          this.#alertService.addAlert({
            type: 'danger',
            message: this.#translateService.instant('ERROR.SAVE_DATA'),
          });
        }).add(() => {
          this.#modalRef.hide();
          this.#spinnerService.hide().then();
        });
  }
}
